(function (Drupal, drupalSettings) {

  'use strict';

  Drupal.behaviors.statusMessages = {
    attach: function (context, settings) {

      function fadeOut(el){
        el.style.opacity = 1;

        (function fade() {
          if ((el.style.opacity -= .1) < 0) {
            el.style.display = "none";
          } else {
            requestAnimationFrame(fade);
          }
        })();
      }

      var statusMessages = document.getElementsByClassName('alert-status-message');
      Array.from(statusMessages).forEach((statusMessage) => {
        // fadeOut(statusMessage);

        var statusMessageCloseButtons = document.getElementsByClassName('alert-status-message-close');
        Array.from(statusMessageCloseButtons).forEach((statusMessageCloseButton) => {
          statusMessageCloseButton.addEventListener('click', function (event) {
            event.preventDefault();
            fadeOut(statusMessage);
            return false;
          });
        });
      });
      
    }
  };
})(Drupal, drupalSettings);
